<article class="block-fullwidth-image container section-outset-y">
  <fstr-image
    [image]="block.image"
    *ngIf="block.image"
    [alt]="block.image.alt || block.title || 'Afbeelding'"
    [imageSizes]="[400, 800, 1400, 1920]"
    [width]="1396"
    [height]="704"
  ></fstr-image>
</article>
